export default "__VITE_ASSET__86b54d67__"